export class ProductCalcModel {

    constructor(DatumFrom: string, DatumTo: string, Quantity: number, CustomerCardsTypeNo?: number, PersTypNo?: number, PoolNo?: number,
        ArtikelNo?: number, RentalItemNo?: number, RentalPersTypeNo?: number, WareSaleItemNo?: number, PackPos?: number, RemainingNo?: number) {

        this.Quantity = Quantity;
        this.CustomerCardsTypeNo = CustomerCardsTypeNo;
        this.PersTypNo = PersTypNo;
        this.PoolNo = PoolNo;
        this.ArtikelNo = ArtikelNo;
        this.RentalItemNo = RentalItemNo;
        this.RentalPersTypeNo = RentalPersTypeNo;
        this.WareSaleItemNo = WareSaleItemNo;
        this.PackPos = PackPos;
        this.RemainingNo = RemainingNo;
        this.DatumFrom = DatumFrom;
        this.DatumTo = DatumTo;
    }

    Quantity: number;
    CustomerCardsTypeNo?: number;
    PersTypNo?: number;
    PoolNo?: number;
    ArtikelNo?: number;
    RentalItemNo?: number;
    RentalPersTypeNo?: number;
    WareSaleItemNo?: number;
    PackPos?: number;
    RemainingNo?: number;
    DatumFrom: string;
    DatumTo: string;
}